module.exports = __webpack_public_path__ + "img/newDetail_zbhl2.97393433.png";